export default __webpack_public_path__ + "static/media/in-game-icon.8436bf0c.png";